export default function (_this) {
  return {
    /**
     * Read settings for current dashboard
     * @param {string} dashId - current dashboard id
     * @param {function} callback - callback function
     */
    read (dashId, callback) {
      _this.root.ref(`settings/${dashId}`).on('value', (snapshot) => {
        callback(snapshot.val())
      })
    },
    /**
     * Save new logo image to settings
     * @param {string} dashId - dashboard id
     * @param {string} newLogoImgSource - new logo image source
     */
    saveLogoImgSource (dashId, newLogoImgSource) {
      _this.root.ref(`settings/${dashId}/logoImgSource`)
        .set(newLogoImgSource, (err) => {
          if (err) console.error(err);
        })
    },
    /**
     * Read settings for current dashboard
     * @param {Function} cb - callback function
     */
    readDashboardSettings (cb) {
      _this.getRef('settings')
        .on('value', (snapshot) => {
          cb(snapshot.val())
        })
    },
    saveDashboardSettings (type, settings, cb) {
      _this.getRef('settings')
        .child(type)
        .set(settings, () => {
          if (cb) cb()
        })
    }
  }
}
